import { cn } from '@/shared/lib/utils'

interface FullscreenLoaderProps {
  className?: string
  message?: string
}

export function FullscreenLoader({ className, message }: FullscreenLoaderProps) {
  return (
    <div
      className={cn(
        'flex min-h-screen flex-col items-center justify-center gap-4 bg-surface',
        className,
      )}
    >
      <span className="size-14 animate-spin rounded-full border-4 border-primary/40 border-t-primary" />
      {message ? <p className="text-sm text-slate-300">{message}</p> : null}
    </div>
  )
}
